import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentDestinationInfo } from '../../../../types/types';

let initial: PaymentDestinationInfo = {
  destination_address: undefined,
  destination_asset: undefined,
  destination_amount: undefined,
  destination_memo: undefined,
  destination_memo_type: undefined,
  destination_username: undefined,
}

const initialState = initial

const paymentDestinationInfo = createSlice({
  name: 'paymentDestinationInfo',
  initialState,
  reducers: {
    setPaymentDestinationInfo: (state, action: PayloadAction<PaymentDestinationInfo>) => {

      return (state = action.payload)

    },
    resetPaymentDestinationInfo: (state) => {

      return (state = initialState)

    },
  },

});

// Reducer
export default paymentDestinationInfo.reducer;

// Actions
export const { setPaymentDestinationInfo, resetPaymentDestinationInfo } = paymentDestinationInfo.actions;